import { render, staticRenderFns } from "./_sboBot.vue?vue&type=template&id=0e1106ce&lang=pug&"
import script from "./_sboBot.vue?vue&type=script&lang=js&"
export * from "./_sboBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports